export interface ContactCategory {
  value: string;
  label: string;
}

export const contactCategories: ContactCategory[] = [
  { value: "product", label: "Product enquiry" },
  { value: "pilot", label: "Private pilot interest" },
  { value: "enterprise", label: "Enterprise" },
  { value: "support", label: "Support" },
  { value: "security", label: "Security" },
  { value: "privacy", label: "Privacy" },
  { value: "legal", label: "Legal" },
  { value: "other", label: "Other" },
];

export const contactFieldLimits = {
  name: 120,
  email: 254,
  organisation: 160,
  message: 4000,
} as const;
